const common = {
  en: {
    siteTitle: "Discover Global Network Travel Guides",
    closeModal: "Close Modal",
    noMatch: "No match for",
    noMatchCopy:
      "Keep in mind, this map displays card acceptance by country and territory.",
    countriesCopy: "Countries",
    search: "Search",
    techDiff: "Looks like something went wrong.",
    techDiffMessage:
      "We ran into some technical difficulties processing your request. Please try again later.",
  },
  es: {
    siteTitle: "Descubra las guías de viaje de Discover Global Network",
    closeModal: "Cerrar Modal",
    noMatch: "No hay coincidencia para",
    noMatchCopy:
      "Tenga en cuenta, este mapa muestra la aceptación de tarjetas por país y territorio.",
    countriesCopy: "Países",
    search: "Buscar",
    techDiff: "Parece que algo salió mal.",
    techDiffMessage:
      "Tuvimos algunas dificultades técnicas al procesar su solicitud. Inténtelo de nuevo más tarde.",
  },
};

export default common;
